import React, { useState, useEffect } from "react";
import { Card, Row, Col, Select, message } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import ReportService from "../../services/ReportService";

const monthLabels = [
  "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
];

const CURRENT_YEAR = new Date().getFullYear();
const CURRENT_MONTH = new Date().getMonth() + 1; // 1-12

type CustomerMonth = {
  month: number;
  accountCount: number;
};

const PartnerMonthlyDashboard: React.FC = () => {
  const [year, setYear] = useState<number>(CURRENT_YEAR);
  const [monthly, setMonthly] = useState<CustomerMonth[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async (y: number) => {
    setLoading(true);
    try {
      const res = await ReportService.getMonthlyCustomerCounts(y);
      setMonthly(res.data);
    } catch {
      setMonthly([]);
      message.error("Veri alınırken hata oluştu!");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData(year);
    // eslint-disable-next-line
  }, [year]);

  const total = monthly.reduce((sum, item) => sum + (item.accountCount ?? 0), 0);

  // Artış/azalış için ok, "gelecek aylar"da gösterilmez
  const getDeltaIcon = (curr: number, prev: number | undefined, idx: number) => {
    if (year === CURRENT_YEAR && idx + 1 > CURRENT_MONTH) return null;
    if (prev === undefined) return null;
    if (curr > prev)
      return <ArrowUpOutlined style={{ color: "#389e0d", marginLeft: 3, fontSize: 18 }} />;
    if (curr < prev)
      return <ArrowDownOutlined style={{ color: "#cf1322", marginLeft: 3, fontSize: 18 }} />;
    return null;
  };

  return (
    <Card
      title="İş Ortağı Dashboard"
      extra={
        <Select
          value={year}
          onChange={setYear}
          style={{ minWidth: 100 }}
          options={Array.from({ length: 6 }).map((_, i) => {
            const y = CURRENT_YEAR - i;
            return { label: y, value: y };
          })}
        />
      }
    >
      <Row gutter={[8, 8]} justify={"space-between"} style={{ marginBottom: 24 }}>
        {monthLabels.map((label, idx) => {
          const value = monthly.find(m => m.month === idx + 1)?.accountCount ?? 0;
          const prevValue = idx > 0 ? (monthly.find(m => m.month === idx)?.accountCount ?? 0) : undefined;
          const isFuture =
            year === CURRENT_YEAR && idx + 1 > CURRENT_MONTH;
          return (
            <Col key={idx}>
              <Card
                bordered={false}
                style={{
                  background: "#f7f7fa",
                  textAlign: "center",
                  width: 110
                }}
              >
                <div style={{ fontSize: 14, color: "#888" }}>{label}</div>
                <div style={{ fontWeight: 700, fontSize: 28, color: "#1764b2" }}>
                  {isFuture ? 0 : value}
                  {idx > 0 && !isFuture && getDeltaIcon(value, prevValue, idx)}
                </div>
              </Card>
            </Col>
          );
        })}
        <Col>
          <Card
            bordered={false}
            style={{
              background: "#e6f4ff",
              textAlign: "center",
              width: 110,
              border: "1.5px solid #1764b2"
            }}
          >
            <div style={{ fontSize: 14, color: "#1764b2" }}>Toplam</div>
            <div style={{ fontWeight: 900, fontSize: 32, color: "#1764b2" }}>
              {total}
            </div>
          </Card>
        </Col>
      </Row>
    </Card>
  );
};

export default PartnerMonthlyDashboard;
